var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuickActionShareIconMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_7909",
    x: 0,
    y: 0,
    width: 45,
    height: 45,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29886",
    "data-name": "Group 29886",
    transform: "translate(9.196 6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27920",
    "data-name": "Group 27920"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9.2, -6)",
    filter: "url(#Rectangle_7909)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7909-2",
    "data-name": "Rectangle 7909",
    width: 27,
    height: 27,
    rx: 3,
    transform: "translate(9 6)",
    fill: "#EB1700"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "share-option",
    transform: "translate(4.266 5.753)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11300",
    "data-name": "Path 11300",
    d: "M18.273,5.142,13,.184a.676.676,0,0,0-.927,0,.579.579,0,0,0-.2.436V3.1H9.564Q2.216,3.1.546,7A8.338,8.338,0,0,0,0,10.226a11.086,11.086,0,0,0,1.309,4.367q.031.068.108.232t.139.29a1.089,1.089,0,0,0,.134.213.357.357,0,0,0,.289.165.31.31,0,0,0,.242-.1.348.348,0,0,0,.087-.242,1.856,1.856,0,0,0-.026-.257,1.886,1.886,0,0,1-.026-.228q-.052-.658-.052-1.191a7.762,7.762,0,0,1,.18-1.753,5.057,5.057,0,0,1,.5-1.341,3.412,3.412,0,0,1,.824-.978A4.877,4.877,0,0,1,4.8,8.735a6.168,6.168,0,0,1,1.371-.412,13.861,13.861,0,0,1,1.587-.208q.8-.058,1.809-.058h2.309v2.479a.579.579,0,0,0,.2.436.677.677,0,0,0,.928,0l5.277-4.958a.583.583,0,0,0,0-.872Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickActionShareIconMobile);
export default __webpack_public_path__ + "static/media/quick-action-share-icon-mobile.7cad1addd4e8959dc61af29c65ed9d9d.svg";
export { ForwardRef as ReactComponent };